<script>
import { QChip, QAvatar } from 'quasar'
import { mergeData } from 'vue-functional-data-merge'
import _ from 'lodash'
export default {
  functional: true,
  props: {
    size: {
      type: String,
      default: 'lg'
    },
    headerText: {
      type: [String, Number]
    },
    headerColor: {
      type: String
    },
    headerTextColor: {
      type: String,
      default: 'white'
    },
    color: {
      type: String
    },
    textColor: {
      type: String,
      default: 'black'
    }
  },
  render: function (createElement, { props, data, children }) {
    if (_.isNumber(props.headerText) || !_.isEmpty(props.headerText)) {
      const headerElement = createElement(QAvatar, {
        props: mergeData({}, { color: props.headerColor, size: props.size, textColor: props.headerTextColor }),
        scopedSlots: {
          default () {
            return String(props.headerText)
          }
        }
      })
      children = children ? [headerElement, ...children] : [headerElement]
    }
    return createElement(QChip, mergeData({ props: { size: props.size, color: props.color, textColor: props.textColor } }, data), children)
  }
}
</script>
